import { displayToast } from "../modules/utils";

export default class LiveValidator {
  constructor(node) {
    this.element = node;
    this.url = this.element.dataset.url;
    this.inputFieldName = this.element.dataset.field;

    this.input = this.element.querySelector("input"); // TODO: might have to add support for other input types
    this.errorElement = document.createElement("span");
    this.errorElement.className = "error-message js-error-message";

    this.timeout;

    this.input.addEventListener("input", () => {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.loadOptions();
      }, 500);
    });
  }

  loadOptions() {
    this.element.classList.add("loading");

    const formData = new FormData();

    let inputName;
    inputName = this.inputFieldName !== undefined && this.inputFieldName !== "" ? this.inputFieldName : this.input.name;

    formData.append(inputName, this.input.value);

    fetch(this.url, {
      retries: 3,
      retryDelay: 1000,
      method: "POST",
      headers: {
        Accept: "application/json",
      },
      body: formData,
    })
      .then((data) => {
        return data.json();
      })
      .then((data) => {
        const { errorMessage, additionalFields } = data;

        const hasError = errorMessage.length > 0;
        this.errorElement.innerText = errorMessage;
        this.input.classList.toggle("input-validation-error", hasError);
        this.element.classList.toggle("input-validation-success", !hasError);

        if (additionalFields !== undefined) {
          this.fillAdditionalFields(additionalFields);
        }

        if (hasError) {
          this.element.appendChild(this.errorElement);
        } else {
          this.errorElement.remove();
        }
      })
      .catch((e) => {
        console.error(e);
        displayToast(this.element.dataset.errorMessage);
        window.Appsignal.sendError(e);
      })
      .finally(() => {
        this.element.classList.remove("loading");
      });
  }

  fillAdditionalFields(values) {
    if (Array.isArray(values)) {
      values.forEach(({ key, value }) => {
        this.fillInField(key, value);
      });
    } else if (typeof values === "object") {
      const { key, value } = values;

      this.fillInField(key, value);
    }
  }

  fillInField(key, value) {
    let valueElement = document.getElementById(key);

    if (valueElement !== null) {
      // Incase there was an error with the other field. We remove the error class
      valueElement.classList.remove("input-validation-error");

      valueElement.value = value;
    }
  }
}
